var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { AnimationEngine } from './Animation';
var Timeline = /** @class */ (function () {
    function Timeline() {
        this.steps = [];
        this._playing = false;
        this._paused = false;
        this.currentIndex = 0;
        this.currentControl = null;
    }
    Timeline.prototype.move = function (target, props) {
        var _a;
        return this.animate(target, __assign(__assign({}, props), { duration: (_a = props.duration) !== null && _a !== void 0 ? _a : 300 }));
    };
    Timeline.prototype.rotate = function (target, degrees, duration) {
        if (duration === void 0) { duration = 300; }
        return this.animate(target, { rotation: target.rotation + degrees, duration: duration });
    };
    Timeline.prototype.scale = function (target, scale, duration) {
        if (duration === void 0) { duration = 300; }
        return this.animate(target, { scaleX: scale, scaleY: scale, duration: duration });
    };
    Timeline.prototype.fade = function (target, opacity, duration) {
        if (duration === void 0) { duration = 300; }
        return this.animate(target, { opacity: opacity, duration: duration });
    };
    Timeline.prototype.animate = function (target, options) {
        this.steps.push({ type: 'animate', target: target, options: options });
        return this;
    };
    Timeline.prototype.wait = function (ms) {
        this.steps.push({ type: 'delay', delay: ms });
        return this;
    };
    Timeline.prototype.call = function (fn) {
        this.steps.push({ type: 'callback', fn: fn });
        return this;
    };
    /** Run the same animation on multiple nodes with staggered start delays. */
    Timeline.prototype.stagger = function (nodes, options, staggerMs) {
        this.steps.push({ type: 'stagger', nodes: nodes, options: options, staggerMs: staggerMs });
        return this;
    };
    Timeline.prototype.play = function () {
        if (this._playing && !this._paused)
            return this;
        this._playing = true;
        this._paused = false;
        this.runStep(this.currentIndex);
        return this;
    };
    Timeline.prototype.pause = function () {
        var _a;
        this._paused = true;
        (_a = this.currentControl) === null || _a === void 0 ? void 0 : _a.stop();
        this.currentControl = null;
        return this;
    };
    Timeline.prototype.stop = function () {
        var _a;
        this._playing = false;
        this._paused = false;
        this.currentIndex = 0;
        (_a = this.currentControl) === null || _a === void 0 ? void 0 : _a.stop();
        this.currentControl = null;
        return this;
    };
    Timeline.prototype.runStep = function (index) {
        var _this = this;
        var _a, _b, _c, _d;
        if (!this._playing || this._paused || index >= this.steps.length) {
            if (index >= this.steps.length) {
                this._playing = false;
                this.currentIndex = 0;
            }
            return;
        }
        this.currentIndex = index;
        var step = this.steps[index];
        if (step.type === 'delay') {
            setTimeout(function () { return _this.runStep(index + 1); }, (_a = step.delay) !== null && _a !== void 0 ? _a : 0);
            return;
        }
        if (step.type === 'callback') {
            (_b = step.fn) === null || _b === void 0 ? void 0 : _b.call(step);
            this.runStep(index + 1);
            return;
        }
        if (step.type === 'stagger' && step.nodes && step.options) {
            var remaining_1 = step.nodes.length;
            if (remaining_1 === 0) {
                this.runStep(index + 1);
                return;
            }
            for (var i = 0; i < step.nodes.length; i++) {
                var node = step.nodes[i];
                var opts = __assign(__assign({}, step.options), { delay: ((_c = step.options.delay) !== null && _c !== void 0 ? _c : 0) + i * ((_d = step.staggerMs) !== null && _d !== void 0 ? _d : 0), onComplete: function () {
                        var _a, _b;
                        (_b = (_a = step.options) === null || _a === void 0 ? void 0 : _a.onComplete) === null || _b === void 0 ? void 0 : _b.call(_a);
                        remaining_1--;
                        if (remaining_1 === 0)
                            _this.runStep(index + 1);
                    } });
                AnimationEngine.animate(node, opts);
            }
            return;
        }
        if (step.type === 'animate' && step.target && step.options) {
            var opts = __assign(__assign({}, step.options), { onComplete: function () {
                    var _a, _b;
                    (_b = (_a = step.options) === null || _a === void 0 ? void 0 : _a.onComplete) === null || _b === void 0 ? void 0 : _b.call(_a);
                    _this.runStep(index + 1);
                } });
            this.currentControl = AnimationEngine.animate(step.target, opts);
        }
    };
    return Timeline;
}());
export { Timeline };
export function parallel(animations) {
    return new Promise(function (resolve) {
        var e_1, _a;
        var remaining = animations.length;
        if (remaining === 0) {
            resolve();
            return;
        }
        var _loop_1 = function (target, options) {
            AnimationEngine.animate(target, __assign(__assign({}, options), { onComplete: function () {
                    var _a;
                    (_a = options.onComplete) === null || _a === void 0 ? void 0 : _a.call(options);
                    remaining--;
                    if (remaining === 0)
                        resolve();
                } }));
        };
        try {
            for (var animations_1 = __values(animations), animations_1_1 = animations_1.next(); !animations_1_1.done; animations_1_1 = animations_1.next()) {
                var _b = animations_1_1.value, target = _b.target, options = _b.options;
                _loop_1(target, options);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (animations_1_1 && !animations_1_1.done && (_a = animations_1.return)) _a.call(animations_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    });
}
